<template>
		
		<div class="row" v-if="this.insidebar == 'on'">
        	<div v-if="this.blogPost != [] && this.blogPost.length > 0">
            	<div class="col-xs-12">
            		 <div class="title-section">
						<h4 class="caption-subject font-green-sharp bold uppercase title">{{ settings['blogcomponent_name'] }} - <span class="caption-helper"><a v-bind:href="this.blogurl" target="_blank"> {{ translations['blog.more'] }}</a></span></h4>
		             </div>
            	</div>
            
            	<div class="col-xs-12 col-sm-4" v-for="post in blogPost">
            		<div class="post">

	            		<a :href="post.link" target="_blank" class="center">
	                    	<figure>                    	
		                        <img v-if="post.blog_image !== false" v-bind:src="post.blog_image" class="blogpost-image">
	                    	</figure>	
	                    	
	                    	<div class="blogpost-title">	                    	
		                    	<p class="blog-date">{{ post.date }}</p>
		                    	<p class="title">{{post.title}}</p>
	                    	</div>
	                   </a>
            		</div>
            		
            	</div>
                
            </div>
            <div v-else>
                <a class="center">
                    <div class="col-xs-12 col-sm-4">
                        <p class="blogpost-title">{{ translations['blog.no_blogs'] }}</p>
                    </div>
                </a>
            </div>
        </div>

     	<!--Sidebar blogposts -->

        <div class="row" v-else>
            <div class="portlet light no-padding leaderboard">
                <div class="portlet-title pd no-margin">
                    <div class="caption caption-md">
                        <span class="caption-subject theme-font bold uppercase">
                            {{ settings['blogcomponent_name'] }}
                        </span>
                    </div>
                </div>
                <div v-if="this.blogPost != []">
                    <a :href="post.link" target="_blank" v-for="post in blogPost" class="blogpost-sidebar col-xs-12">
                        <tr>
                            <td>
                                <div class="image-wrapper">
                                    <img v-if="post.blog_image !== false" v-bind:src="post.blog_image" class="blogpost-image-sidebar">
                                </div>
                            </td>
                            <td class="blogpost-title-sidebar">
                                <span class="blog-date">{{post.date}}</span>
                                <span class="blog-title-text">{{post.title}}</span>
                            </td>
                        </tr>
                    </a>
                </div>
                <div v-else>
                    <a class="blogpost-sidebar col-xs-12">
                        <tr>
                            <td class="blogpost-title-sidebar">
                                <p>{{ translations['blog.no_blogs'] }}</p>
                            </td>
                        </tr>
                    </a>
                </div>

                <div class="task-footer m-t">
                    <div class="btn-arrow-link pull-right">
                        <a v-bind:href="this.blogurl" target="_blank" class="btn default btn-sm pull-right m-b m-r" >  {{ translations['blog.more'] }} <i class="fa fa-angle-right"></i></a>
                    </div>
                </div>
            </div>

        </div>

</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: "BlogFeed",

        props: ['insidebar','blogurl'],

        data() {
            return {
                blog_position: this.insidebar
            }
        },

        computed: {
            // Grab these states from store.
            ...mapState([
                'settings',
                'translations',
                'blogPost',
                'emptyBlogImage',
            ]),
        },

        mounted() {
            this.$store.dispatch('getBlogPosts');
        }
    }

</script>

<style lang="scss" scoped>

    $gray: #808080;
	$light-gray: #a1a1a1;
	
	h4 {
		margin-top:1em;
		margin-bottom: 1.5em;
	}
	.post {
		background: #fff;
		border-radius: 2px;
		min-height: 226px;
		
		 &:hover {
         	background: darken(#fff, 2%);
            color: lighten($gray, 2%);
			text-decoration: none;
		}
		&:active {
			text-decoration: none;
		}
	}
	figure {
		max-height: 144px;
    	overflow: hidden;
   		width: 100%;
   		
   		img {
   		    width: 100%;
        }
	}

    .blogpost-title {
        font-weight: 600;
        font-size: 14px;
        color: #333;
        padding: 12px;
        height: 150px;
        
        .blog-date{
		            color:$gray;
		            font-size:11px;
		              
        }
		            
       
    		
	}
		
	.caption-helper {
		a { 
			color: $light-gray;
		}
		
		font-size:12px;
	}
    .blogpost-image {
        width: 100%;
        max-height: 200px;
    }

    
	
    /* Blogposts in sidebar */

    .blogpost-sidebar{
        padding-left: 7px;

        .image-wrapper{
            height: 50px;
            object-fit: cover;

            .blogpost-image-sidebar {
                width: 100px;
                height: 100%;
                object-fit: cover;
            }
        }

        .blogpost-title-sidebar{
            position: relative;
            top: -8px;

            .blog-date{
                color: $gray;
            }

            .blog-title-text{
                color: #333;
            }

            span{
                font-size:.9em;
            }
        }

        &:hover{
            text-decoration:underline;
        }
    }




</style>